import classnames from 'classnames2';
import { DateTime, Duration } from 'luxon';
import React from 'react';

import { Link } from '@opengov/component-library';

import styles from './AdminBar.module.scss';

export const getPromotedTime = (time) => {
  const hours = Math.round(Duration.fromObject(DateTime.fromISO(time).diffNow().toObject()).as('hours'));
  const minutes =
    Math.round(Duration.fromObject(DateTime.fromISO(time).diffNow().toObject()).as('minutes')) - hours * 60;

  const hoursString = hours > 0 ? `${hours} ${hours > 1 ? 'hours' : 'hour'}` : '';
  const minuteString = minutes > 0 ? `${minutes} ${minutes > 1 ? 'minutes' : 'minute'}` : '';

  return hours > 0 || minutes > 0
    ? `Promoted for ${hoursString}${hoursString && minuteString ? ' and ' : ''}${minuteString}`
    : 'Demoting now...';
};

export interface IAdminBarProps {
  userDemotedAt?: string;
  entityName: string;
  environmentName: string;
  showEnvironment: boolean;
  onSwitchEntity(): void;
}

export const AdminBar: React.FC<IAdminBarProps> = ({
  userDemotedAt,
  entityName,
  environmentName,
  showEnvironment,
  onSwitchEntity
}) => (
  <div className={styles.container}>
    <div>
      Viewing{' '}
      <span className={styles.entityName} data-test="admin-bar-entity-name">
        {entityName}
      </span>
      {`, `}
      <Link.Quiet as="button" text="Switch" onClick={onSwitchEntity} dataTest="admin-bar-switch-entity-btn" />
    </div>
    {userDemotedAt && (
      <span className={styles.userPromoted} data-test="admin-bar-promoted-msg">
        {getPromotedTime(userDemotedAt)}
      </span>
    )}
    {showEnvironment && (
      <div
        className={classnames(styles.environment, environmentName.toLowerCase() === 'production' && styles.production)}
        data-test="admin-bar-environment-name"
      >
        {environmentName}
      </div>
    )}
  </div>
);
